const mercuryDevices = {
  MERCURY_W_LCD_C: "MERCURY_W_LCD_C",
  MERCURY_W_LB_C: "MERCURY_W_LB_C",
  MERCURY_L_LCD_C: "MERCURY_L_LCD_C",
  MERCURY_L_LB_C: "MERCURY_L_LB_C"
};

export default mercuryDevices;
